var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7144 11.6574V23.2137C24.7144 23.7441 24.5036 24.2528 24.1286 24.6279C23.7535 25.003 23.2448 25.2137 22.7144 25.2137H17.7144C17.1839 25.2137 16.6752 25.003 16.3001 24.6279C15.9251 24.2528 15.7144 23.7441 15.7144 23.2137V18.2137C15.7144 17.9485 15.609 17.6941 15.4215 17.5066C15.2339 17.319 14.9796 17.2137 14.7144 17.2137H10.7144C10.4491 17.2137 10.1948 17.319 10.0072 17.5066C9.81971 17.6941 9.71436 17.9485 9.71436 18.2137V23.2137C9.71436 23.7441 9.50364 24.2528 9.12857 24.6279C8.7535 25.003 8.24479 25.2137 7.71436 25.2137H2.71436C2.18392 25.2137 1.67521 25.003 1.30014 24.6279C0.925069 24.2528 0.714355 23.7441 0.714355 23.2137V11.6574C0.714313 11.3806 0.771729 11.1068 0.88297 10.8534C0.99421 10.5999 1.15685 10.3723 1.36061 10.1849L11.3606 0.749944L11.3744 0.736194C11.7425 0.401361 12.2223 0.21582 12.72 0.21582C13.2176 0.21582 13.6974 0.401361 14.0656 0.736194C14.0699 0.741085 14.0745 0.74568 14.0794 0.749944L24.0794 10.1849C24.2811 10.3733 24.4416 10.6014 24.5509 10.8548C24.6602 11.1082 24.7158 11.3815 24.7144 11.6574Z",
    fill: "#2C3D68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.578b1e8f580fc91a9d9dff46674a34c4.svg";
export { ForwardRef as ReactComponent };